export class CorporateCirabooksSideNavigationTree {
    static topItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CORPORATE_CIRABOOKS_HOME',
            path: '/ccb/home',
            icon: '',
            text: 'CiraBooks Corporate Workspace',
            tooltip: 'CiraBooks Corporate Workspace',
            items: [],
            isWorkspace: true
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_AP',
            path: null,
            icon: '',
            text: 'Accounts Payable',
            tooltip: 'Accounts Payable',
            items: CorporateCirabooksSideNavigationTree.topAPItems(`${parentId}_2`)
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_RM',
            path: null,
            icon: '',
            text: 'Revenue Management',
            tooltip: 'Revenue Management',
            items: CorporateCirabooksSideNavigationTree.topRMItems(`${parentId}_3`)
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_TEM',
            path: null,
            icon: '',
            text: 'Time & Expense Management',
            tooltip: 'Time & Expense Management',
            items: CorporateCirabooksSideNavigationTree.topTEMItems(`${parentId}_4`)
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CCB_ENTITY',
            path: null,
            icon: '',
            text: 'Entity',
            tooltip: 'Entity',
            items: CorporateCirabooksSideNavigationTree.topEntityItems(`${parentId}_5`)
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CCB_GL',
            path: null,
            icon: '',
            text: 'General Ledger',
            tooltip: 'General Ledger',
            items: CorporateCirabooksSideNavigationTree.topGLItems(`${parentId}_6`)
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CCB_AR',
            path: null,
            icon: '',
            text: 'Accounts Receivable',
            tooltip: 'Accounts Receivable',
            items: CorporateCirabooksSideNavigationTree.topARItems(`${parentId}_7`)
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CCB_REPORTS',
            path: '/ccb/reports',
            icon: '',
            text: 'Reports',
            tooltip: 'Reports',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CCB_CM',
            path: null,
            icon: '',
            text: 'Cash Management',
            tooltip: 'Cash Management',
            items: CorporateCirabooksSideNavigationTree.topCMItems(`${parentId}_9`)
        }
    ];

    static topAPItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_AP_BILLS_TO_PAY',
            path: '/ccb/ap/billstopay',
            icon: '',
            text: 'Select Bills to Pay',
            tooltip: 'Select Bills to Pay',
            items: []
        },

        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_AP_LEDGER',
            path: '/ccb/ap/apledger',
            icon: '',
            text: 'AP Ledger',
            tooltip: 'AP Ledger',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_AP_VENDOR_MANAGEMENT',
            path: '/ccb/ap/vendormanagement',
            icon: '',
            text: 'Vendor Management',
            tooltip: 'Vendor Management',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_AP_VENDOR_1099',
            path: '/ccb/ap/vendor1099',
            icon: '',
            text: 'Vendor 1099',
            tooltip: 'Vendor 1099',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CCB_VENDOR_AGING',
            path: '/ccb/ap/vendoraging',
            icon: '',
            text: 'Vendor Aging',
            tooltip: 'Vendor Aging',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CCB_AP_BILL_ANALYSIS',
            path: '/ccb/ap/billanalysis',
            icon: '',
            text: 'AP Bill Analysis',
            tooltip: 'AP Bill Analysis',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CCB_AP_BATCHES',
            path: '/ccb/ap/batches',
            icon: '',
            text: 'AP Batches',
            tooltip: 'AP Batches',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CCB_AP_WORK_QUEUE',
            path: '/ccb/ap/workqueuemanagement',
            icon: '',
            text: 'Work Queue Management',
            tooltip: 'Work Queue Management',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CCB_AP_NEW_BILL',
            path: '/ccb/ap/newbill',
            icon: '',
            text: 'New AP Bill',
            tooltip: 'New AP Bill',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'CCB_AP_EFT_MANAGEMENT',
            path: '/ccb/ap/eftpaymentmanagement',
            icon: '',
            text: 'EFT Payment Management',
            tooltip: 'EFT Payment Management',
            items: []
        },
        {
            id: `${parentId}_11`,
            parentId,
            name: 'CCB_CHECK_PRINTING',
            path: '/ccb/ap/checkprinting',
            icon: '',
            text: 'Check Printing Management',
            tooltip: 'Check Printing Management',
            items: []
        }
    ];

    static topRMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_RM_BILLING_ITEM_MANAGEMENT',
            path: '/gcb/rm/billingitem',
            icon: '',
            text: 'Billing Item Management',
            tooltip: 'Billing Item Management',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_RM_BILLING_QUEUE_MANAGEMENT',
            path: '/gcb/rm/billingqueue',
            icon: '',
            text: 'Billing Queue Management',
            tooltip: 'Billing Queue Management',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_RM_CUSTOMER_CONTRACTS',
            path: '/ccb/rm/customercontracts',
            icon: '',
            text: 'Customer Contracts',
            tooltip: 'Customer Contracts',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_RM_SETUP',
            path: null,
            icon: '',
            text: 'Setup',
            tooltip: 'Setup',
            items: CorporateCirabooksSideNavigationTree.topRMSetupItems(`${parentId}_4`)
        }
    ];

    static topRMSetupItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_RM_PRODUCT_CATEGORY_SETUP',
            path: '/ccb/rm/productcatgorysetup',
            icon: '',
            text: 'Product Categories',
            tooltip: 'Product Categories',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_RM_SETUP_BILLING_ITEM_CATEGORY',
            path: '/ccb/rm/setup/billingitemcategory',
            icon: '',
            text: 'Billing Item Categories',
            tooltip: 'Billing Item Categories',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_RM_CUSTOMER_CATEGORY',
            path: '/ccb/rm/customercategories',
            icon: '',
            text: 'Customer Categories',
            tooltip: 'Customer Categories',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_RM_CONTRACT_FORMS',
            path: '/ccb/rm/contractforms',
            icon: '',
            text: 'Contract Forms',
            tooltip: 'Contract Forms',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CCB_RM_SUBSCRIPTION',
            path: '/ccb/rm/subscriptionsetup',
            icon: '',
            text: 'Subscriptions',
            tooltip: 'Subscriptions',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CCB_RM_PRODUCTS',
            path: '/ccb/rm/setup/productsetup',
            icon: '',
            text: 'Products',
            tooltip: 'Products',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CCB_RM_BILLING_RULES_SETUP',
            path: '/ccb/rm/setup/billingrules',
            icon: '',
            text: 'Billing Rules',
            tooltip: 'Billing Rules',
            items: []
        }
    ];

    static topTEMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_TEM_SETUP',
            path: null,
            icon: '',
            text: 'Setup',
            tooltip: 'Setup',
            items: CorporateCirabooksSideNavigationTree.topTEMSetupItems(`${parentId}_1`)
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_TE_PAYROLL_REIMBURSEMENT',
            path: '/ccb/te/payrollreimbursement',
            icon: '',
            text: 'Payroll Reimbursement',
            tooltip: 'Payroll Reimbursement',
            items: []
        }
    ];

    static topTEMSetupItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_TE_SETUP_CHARGE_RATE_CATEGORY',
            path: '/ccb/tem/chargeratecategory',
            icon: '',
            text: 'Charge Rate Categories',
            tooltip: 'Charge Rate Categories',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_TE_SETUP_CHARGE_RATE',
            path: '/ccb/tem/chargerate',
            icon: '',
            text: 'Charge Rates',
            tooltip: 'Charge Rates',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_TE_SETUP_CHARGE_CODE_CATEGORY',
            path: '/ccb/tem/chargecodecategory',
            icon: '',
            text: 'Charge Code Categories',
            tooltip: 'Charge Code Categories',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_TE_SETUP_CHARGE_CODE',
            path: '/ccb/tem/chargecodesetup',
            icon: '',
            text: 'Charge Codes',
            tooltip: 'Charge Codes',
            items: []
        }
    ];

    static topGLItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_GL_OPEN_CLOSE_BOOK',
            path: '/ccb/gl/openclosebooks',
            icon: '',
            text: 'Open/Close Books',
            tooltip: 'Open/Close Books',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_GL_REPORT',
            path: '/ccb/gl/report',
            icon: '',
            text: 'General Ledger Report',
            tooltip: 'General Ledger Report',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_GL_BUDGET',
            path: '/ccb/gl/budget',
            icon: '',
            text: 'Budget',
            tooltip: 'Budget',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_GL_JOURNAL_ENTRY',
            path: '/ccb/gl/journal-entries',
            icon: '',
            text: 'Journal Entries',
            tooltip: 'Journal Entries',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CCB_GL_UPLOAD_BUDGETS',
            path: '/ccb/gl/uploadbudgets',
            icon: '',
            text: 'Upload Budgets',
            tooltip: 'Upload Budgets',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CCB_GL_JETEMPLATE',
            path: '/ccb/gl/jeTemplate',
            icon: '',
            text: 'Journal Entry Template',
            tooltip: 'Journal Entry Template',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CCB_GL_UPLOAD_JE',
            path: '/ccb/gl/uploadjournalentry',
            icon: '',
            text: 'Upload JEs',
            tooltip: 'Upload JEs',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CCB_GL_TRIAL_BALANCE',
            path: '/ccb/gl/trialbalance',
            icon: '',
            text: 'Trial Balance',
            tooltip: 'Trial Balance',
            items: []
        }
    ];

    static topARItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_AR_LEDGER',
            path: '/ccb/ar/arledger',
            icon: '',
            text: 'AR Ledger',
            tooltip: 'AR Ledger',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_AR_INVOICE_ANALYSIS',
            path: '/ccb/ar/arinvoiceanalysis',
            icon: '',
            text: 'AR Invoice Analysis',
            tooltip: 'AR Invoice Analysis',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_AR_CUSTOMER_AGING',
            path: '/ccb/ar/customeraging',
            icon: '',
            text: 'Customer Aging',
            tooltip: 'Customer Aging',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_AR_BATCHES',
            path: '/ccb/ar/batches',
            icon: '',
            text: 'AR Batches',
            tooltip: 'AR Batches',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CCB_AR_NEW_PAYMENT',
            path: '/ccb/ar/createarpayment',
            icon: '',
            text: 'New AR Payment',
            tooltip: 'New AR Payment',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CCB_AR_NEW_INVOICE',
            path: '/ccb/ar/createarinvoice',
            icon: '',
            text: 'New AR Invoice',
            tooltip: 'New AR Invoice',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CCB_AR_NEW_ADJUSTMENT',
            path: '/ccb/ar/createaradjustment',
            icon: '',
            text: 'New AR Adjustment',
            tooltip: 'New AR Adjustment',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CCB_AR_CUSTOMER_MANAGEMENT',
            path: '/ccb/ar/customer-management',
            icon: '',
            text: 'Customer Management',
            tooltip: 'Customer Management',
            items: []
        }
    ];

    static topCMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_CM_BATCHES',
            path: '/ccb/cm/batches',
            icon: '',
            text: 'CM Batches',
            tooltip: 'CM Batches',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_CM_CASH_RECEIPT',
            path: '/ccb/cm/cashreceipts',
            icon: '',
            text: 'Cash Receipts',
            tooltip: 'Cash Receipts',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CCB_CM_DEPOSIT',
            path: '/ccb/cm/deposits',
            icon: '',
            text: 'Deposits',
            tooltip: 'Deposits',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CCB_CM_BANK_ACCOUNTS',
            path: '/ccb/cm/bankaccounts',
            icon: '',
            text: 'Bank Accounts',
            tooltip: 'Bank Accounts',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CCB_CM_BANK_REC',
            path: '/ccb/cm/bankreconciliation',
            icon: '',
            text: 'Reconcile Bank Account',
            tooltip: 'Reconcile Bank Account',
            items: []
        }
    ];

    static topEntityItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CCB_ENTITY_AUDIT_LOG',
            path: '/ccb/entity/auditlog',
            icon: '',
            text: 'Audit Log',
            tooltip: 'Audit Log',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CCB_CONFIGURATIONS',
            path: '/ccb/entity/configuration',
            icon: '',
            text: 'Configuration',
            tooltip: 'Configuration',
            items: []
        }
    ];
}
